'use client'
/***
 *
 * @file components/Stepper/PrevStep.tsx
 * @description Prev Step component will be used to move to the previous step.
 * @author Ayesha Kumar
 * @organization Truminds Software System
 * @since 7 Jan 2026
 *
 */

import { ReactNode, useEffect, useRef } from "react";

type Props = {
  id?: string,
  children: ReactNode,
  event?: string,
}


const PrevStep = ({ id, children, event = "click" }: Props) => {

  const prevStepRef = useRef<HTMLDivElement | null>(null)

  const emitEvent = (e: Event) => {
    prevStepRef?.current?.dispatchEvent(new Event("prev_step", { bubbles: true }))
  }

  useEffect(() => {
    prevStepRef?.current?.addEventListener(event, emitEvent);

    return () => {
      prevStepRef?.current?.removeEventListener(event, emitEvent);
    }
  }, [])


  return (
    <div className="PrevStep-container" id={id} ref={prevStepRef} data-testid="PrevStep">
      {children}
    </div>
  );
};

export default PrevStep;
